var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEmployeList(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 32 32",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 14"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M26 29.75H6A1.752 1.752 0 0 1 4.25 28V9.414a1.739 1.739 0 0 1 .513-1.237l5.414-5.414a1.739 1.739 0 0 1 1.237-.513H26A1.752 1.752 0 0 1 27.75 4v24A1.752 1.752 0 0 1 26 29.75zm-14.586-26a.253.253 0 0 0-.177.073L5.823 9.237a.253.253 0 0 0-.073.177V28a.25.25 0 0 0 .25.25h20a.25.25 0 0 0 .25-.25V4a.25.25 0 0 0-.25-.25z",
    opacity: 1,
    "data-original": "#232323",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M10 9.75H5.1a.75.75 0 0 1 0-1.5H10a.253.253 0 0 0 .25-.25V3.1a.75.75 0 1 1 1.5 0V8A1.752 1.752 0 0 1 10 9.75z",
    opacity: 1,
    "data-original": "#232323",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M22.531 16.508h-4.16a2.122 2.122 0 0 1-2.121-2.12v-.285a3.512 3.512 0 0 1 1.62-2.94A3.05 3.05 0 1 1 23.434 8.9a3.081 3.081 0 0 1-.404 2.264 3.51 3.51 0 0 1 1.62 2.94v.286a2.122 2.122 0 0 1-2.12 2.12zM20.45 7.992a1.53 1.53 0 0 0-.991.36 1.548 1.548 0 0 0 .113 2.463.75.75 0 0 1-.264 1.35 2.001 2.001 0 0 0-1.557 1.938v.286a.62.62 0 0 0 .62.62h4.161a.62.62 0 0 0 .62-.62v-.286a2.001 2.001 0 0 0-1.556-1.939.75.75 0 0 1-.264-1.349 1.548 1.548 0 0 0-.583-2.797 1.688 1.688 0 0 0-.3-.026z",
    opacity: 1,
    "data-original": "#7fbde7",
    className: ""
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#232323"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23 19.75H9a.75.75 0 0 1 0-1.5h14a.75.75 0 0 1 0 1.5zM14 16.25H9a.75.75 0 0 1 0-1.5h5a.75.75 0 0 1 0 1.5zM14 12.75H9a.75.75 0 0 1 0-1.5h5a.75.75 0 0 1 0 1.5zM23 23.25H9a.75.75 0 0 1 0-1.5h14a.75.75 0 0 1 0 1.5zM23 26.75H9a.75.75 0 0 1 0-1.5h14a.75.75 0 0 1 0 1.5z",
    fill: "#ffffff",
    opacity: 1,
    "data-original": "#232323",
    className: ""
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmployeList);
export default __webpack_public_path__ + "static/media/employe-list.a4be1521c6e176e01a7124134b98ba2a.svg";
export { ForwardRef as ReactComponent };